import { render } from "./OrdersTopBarCard.vue?vue&type=template&id=6e1d2848&scoped=true"
import script from "./OrdersTopBarCard.vue?vue&type=script&lang=js"
export * from "./OrdersTopBarCard.vue?vue&type=script&lang=js"

import "./OrdersTopBarCard.vue?vue&type=style&index=0&id=6e1d2848&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1d2848"]])

export default __exports__